export default "__VITE_ASSET__BZNGkUic__"